import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { PayPalScriptProvider, usePayPalScriptReducer } from "@paypal/react-paypal-js";
import api from "../lib/api";

// One SDK configuration for the app's already-supported payment methods.
const OPTIONS = { currency: "USD", intent: "capture", components: "buttons", "disable-funding": "paylater,credit", "enable-funding": "venmo,card" };
const PayPalContext = createContext(null);

const PayPalConfiguration = ({ children }) => {
    const [, dispatch] = usePayPalScriptReducer();
    const [requested, setRequested] = useState(false), [config, setConfig] = useState(null), [loadError, setLoadError] = useState("");
    const requestLoad = useCallback(() => setRequested(true), []);
    useEffect(() => {
        if (!requested) return;
        let active = true;
        api.get("/paypal/config").then(({ data }) => {
            if (!active) return;
            if (!data.configured || !data.client_id) { setLoadError("PayPal is not configured on the server."); return; }
            setConfig(data);
            dispatch({ type: "resetOptions", value: { ...OPTIONS, clientId: data.client_id } });
        }).catch(() => { if (active) setLoadError("Could not reach PayPal config endpoint."); });
        return () => { active = false; };
    }, [requested, dispatch]);
    const value = useMemo(() => ({ config, loadError, requestLoad }), [config, loadError, requestLoad]);
    return <PayPalContext.Provider value={value}>{children}</PayPalContext.Provider>;
};

export const SharedPayPalProvider = ({ children }) => <PayPalScriptProvider deferLoading options={OPTIONS}><PayPalConfiguration>{children}</PayPalConfiguration></PayPalScriptProvider>;
export const useSharedPayPal = () => useContext(PayPalContext);